import {
  LookupApi,
  IcdCodesApi,
  LocationApi,
  WorkflowsApi,
  ContactTypeApi,
  PeripheralDevicesApi,
  UserNotificationsApi,
  PatientNotificationsApi
} from "common-util-experience-client";
import { createCommonConfigurationForApis } from "./CommonHelper";
import { spire360ApiClient } from "./Spire360ApiClient";
import { AxiosInstance } from "axios";

export function createCommonUtilsApi(): LookupApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_LOOKUP_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new LookupApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
    );
  } else {
    return new LookupApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
    );
  }
}
export function createCommonUtilsIcdApi(): IcdCodesApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_ICDCODES_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new IcdCodesApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
      // "http://localhost:4070"
    );
  } else {
    return new IcdCodesApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
      // "http://localhost:4070"
    );
  }
}
export function createLocationApi(): LocationApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_LOCATION_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new LocationApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
    );
  } else {
    return new LocationApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
    );
  }
}

export function createWorkflowApi(): WorkflowsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_WORKFLOW_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new WorkflowsApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
      // "http://localhost:4070"
    );
  } else {
    return new WorkflowsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
      // "http://localhost:4070"
    );
  }
}

export function createContactTypeApi(): ContactTypeApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_COMMONUTILS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new ContactTypeApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
    );
  } else {
    return new ContactTypeApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
    );
  }
}

export function createPeripheralDevicesApi(): PeripheralDevicesApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_COMMONUTILS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new PeripheralDevicesApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
      // "http://localhost:4070"
    );
  } else {
    return new PeripheralDevicesApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
      // "http://localhost:4070"
    );
  }
}

export function createUserNotificationsApi(): UserNotificationsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_COMMONUTILS_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new UserNotificationsApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
      // "http://localhost:4070"
    );
  } else {
    return new UserNotificationsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
      // "http://localhost:4070"
    );
  }
}

export function createPatientNotificationApi(): PatientNotificationsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_LOOKUP_API_URL;
    const axiosInstance: AxiosInstance = spire360ApiClient; // Note: basePath handled by baseURL in request config if needed
    // const basePath = basePath!);
    return new PatientNotificationsApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance
    );
  } else {
    return new PatientNotificationsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`
    );
  }
}
